import $ from 'jquery';
import whatInput from 'what-input';
import Foundation from 'foundation-sites';

import Marquee3k from 'marquee3000';
import lightbox2 from 'lightbox2';
//import lightgallery from 'lightgallery';

window.$ = $;


// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(document).ready(function(){
	$('#nav-icon').click(function(){
		$('#nav-icon').toggleClass('open');
		revealOverlay();
	});

	Marquee3k.init()
	//Marquee3k.refreshAll();


});

//////////////////////////////
// Reveal menu with revealOverlay()
//////////////////////////////

function revealOverlay() {
  document.getElementById("overlayMenu").classList.toggle("overlay-reveal");
  document.body.classList.toggle('noscroll');
}

//////////////////////////////
// Get variable height of fixed header
//////////////////////////////
// var height = document.getElementById("site-header").offsetHeight;
// document.getElementById("page").style.paddingTop = height + 'px';
// document.getElementById("overlayMenu").style.paddingTop = height + 'px';
//

// Prevent small screen page refresh sticky bug
$(window).on('sticky.zf.unstuckfrom:bottom', function(e) {
  if (!Foundation.MediaQuery.atLeast('medium')) {
    $(e.target).removeClass('is-anchored is-at-bottom').attr('style', '');
  }
});
